// Package
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        label:{
            type: String,
            required: true,
            default: "",
        },
        name:{
            type: String,
            required: true,
            default: "",
        },
        errors:{
            type: Object,
            required: false,
            default: ()=>{},
        },
        information:{
            type: String,
            required: false,
            default: null,
        },
        accept:{
            type: String,
            required: false,
            default: '*',
        }
    }
})